
import SearchBar from '@/components/searchbar/searchBar.vue'
export default {

    components: {
        SearchBar
    },
    


}
